import {
  asosGlobalNamespace,
  sdkGlobalNamespace,
  customerGlobalNamespace,
  savedItemsSdkGlobalNamespace
} from "../../template/constants";

export const initialise = context => {
  const { getAuthHeader: getAuthorisation } =
    window[asosGlobalNamespace][sdkGlobalNamespace].identity;
  const interactionCallback = () => {
    if (window.newrelic) {
      window.newrelic.interaction().save();
    }
  };

  return window[asosGlobalNamespace][customerGlobalNamespace][
    savedItemsSdkGlobalNamespace
  ].sdk({ context, configuration: { getAuthorisation, interactionCallback } });
};
